import React from "react";
import { StyledLabel, StyledTextInput } from "@aureskonnect/react-ui";
import { AvGroup } from "availity-reactstrap-validation";
import classnames from "classnames";

import { useMoneticsForm } from "../MoneticsFormContext";

/** Optional free-text "Remark" input. */
export function RemarkField() {
    const { form, props } = useMoneticsForm();
    const { t, remarque, setRemarque } = form;
    const { isConsult, setIsEdited } = props;

    return (
        <AvGroup>
            <StyledLabel className="mt-3" htmlFor="text">
                {t("Remark")}
            </StyledLabel>
            <StyledTextInput
                className={classnames("mnt_inp_remark", {
                    readOnly__clz: isConsult,
                })}
                data-testid="monetics-remark-input"
                autocomplete="off"
                name="remarque"
                onChange={(e: any) => {
                    setRemarque(e.target.value);
                    setIsEdited(true);
                }}
                value={remarque}
                placeholder={t("Write")}
                type="text"
            />
        </AvGroup>
    );
}
